import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Card, Descriptions, Modal, message, Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { generateCSV } from '../../utils/helpres';
import moment from 'moment';

const User = () => {
    const [user, setUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [providersStats, setProvidersStats] = useState({});
    const [patients, setPatients] = useState([]);
    const [invoiceHistory, setInvoiceHistory] = useState([]);
    const { id, type } = useParams()
    const { navigate } = useNavigate()

    const fetchUsers = useCallback(() => {
        setUser(null);
        axios
            .get(`/admins/${type}/${id}`)
            .then(({ data }) => {
                setUser(data);
            })
            .catch((error) => {
                navigate('/');
            });
    }, [])

    useEffect(() => {
        if (id && type) {
            fetchUsers()
        }
    }, [id, type, navigate]);

    const kickUser = useCallback(() => {
        axios.patch(`/admins/${type}/${id}/kick`,)
            .then(({ data }) => {
                if (data) {
                    setShowModal(false)
                    fetchUsers()
                    message.success(user.isKicked ? "User approved" : "User kicked");
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }, [user])

    const getUsersCSV = () => {
        axios.get(`/admins/users-download/${type}`, {
            params: {
                id
            }
        })
            .then(({ data }) => {
                const output = generateCSV(data);
                const blob = new Blob([output], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.setAttribute('href', url);
                a.setAttribute('download', `${id}-user.csv`);
                a.click();
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (type === 'provider') {
            axios.get(`/admins/providers/${id}/stats`)
                .then(({ data }) => {
                    setProvidersStats(data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }

        if (type === 'customer') {
            axios.get(`/admins/customers/${id}/stats`)
                .then(({ data }) => {
                    setProvidersStats(data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }

        if (type === 'partner') {
            axios.get(`/admins/partners/${id}/stats`)
                .then(({ data }) => {
                    setProvidersStats(data);
                    setInvoiceHistory(data.invoiceHistory || []);
                    setPatients(data)
                })
                .catch((err) => {
                    console.error('Error fetching partner stats:', err.response?.data || err);
                })


            axios.get(`/admins/partners/${id}/patients`)
                .then(({ data }) => {
                    setPatients(data)
                })
                .catch((err) => {
                    console.error('Error fetching partner stats:', err.response?.data || err);
                })
        }
    }, [type, id])

    const patientsColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Surname',
            dataIndex: 'surname',
            key: 'surname',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Email Notifications',
            dataIndex: 'emailNotifications',
            key: 'emailNotifications',
            render: (value) => (
                <Tag color={value ? 'green' : 'red'}>
                    {value ? 'Enabled' : 'Disabled'}
                </Tag>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Link to={`/patients/${record._id}`}>
                    <Button type="link">View Profile</Button>
                </Link>
            ),
        },
    ];

    const invoiceColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (date) => moment(date).format('MMM D, YYYY'),
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount) => `$${parseFloat(amount).toFixed(2)}`,
        },
        {
            title: 'Jobs',
            dataIndex: 'jobs',
            key: 'jobs',
            render: (jobs) => jobs.length,
        },
    ];

    return (
        <div className='user'>
            <Modal
                width={500}
                title="Confirm your action"
                open={showModal}
                onCancel={() => setShowModal(false)}
                centered
                footer={[
                    <Button key="submit" type="primary" danger onClick={kickUser}>
                        Confirm
                    </Button>
                ]}
            >
                <p>{`Are you sure you want to ${user?.isKicked ? "approve" : "kick"} this user?`}</p>
            </Modal>
            {user && (
                <>
                    <Card className="card">
                        <Descriptions title="User Info" >
                            <Descriptions.Item label="Name">{user.name}</Descriptions.Item>
                            <Descriptions.Item label="Surname">{user.surname}</Descriptions.Item>
                            <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
                            <Descriptions.Item label="Registration date">{new Date(user.date_create).toLocaleDateString()}</Descriptions.Item>
                            <Descriptions.Item label="User type">{type}</Descriptions.Item>
                            <Descriptions.Item label="User is">{user.isKicked ? "kicked" : "not kicked"}</Descriptions.Item>
                            {type === 'partner' && (
                                <>
                                    <Descriptions.Item label="Company Name">{user.companyName}</Descriptions.Item>
                                    <Descriptions.Item label="Company Type">{user.companyType}</Descriptions.Item>
                                    <Descriptions.Item label="EIN">{user.ein}</Descriptions.Item>
                                    <Descriptions.Item label="Approved">{user.isApproved ? "Yes" : "No"}</Descriptions.Item>
                                    <Descriptions.Item label="Current Invoice">${providersStats.currentInvoice?.toFixed(2) || '0.00'}</Descriptions.Item>
                                </>
                            )}
                            {type !== 'partner' && (
                                <>
                                    <Descriptions.Item label="Completed">{providersStats.totalCompleted}</Descriptions.Item>
                                    <Descriptions.Item label="Canceled">{providersStats.totalCanceled}</Descriptions.Item>
                                    <Descriptions.Item label="Late canceled">{providersStats.totalLateCanceled}</Descriptions.Item>
                                </>
                            )}
                        </Descriptions>
                        <div className="btn-container">
                            <Button
                                type='primary'
                                onClick={getUsersCSV}
                            >
                                Download user data
                            </Button>
                            <Button
                                className='btn'
                                onClick={() => setShowModal(true)}
                            >
                                {user.isKicked ? "Approve" : "Kick"} user
                            </Button>
                        </div>
                    </Card>

                    {type === 'partner' && (
                        <>
                            <Card className="card" style={{ marginTop: '20px' }}>
                                <h3 style={{ marginBottom: '16px' }}>Patients</h3>
                                <Table
                                    dataSource={patients}
                                    columns={patientsColumns}
                                    rowKey="_id"
                                />
                            </Card>

                            <Card className="card" style={{ marginTop: '20px' }}>
                                <h3 style={{ marginBottom: '16px' }}>Invoice History</h3>
                                <Table
                                    dataSource={invoiceHistory}
                                    columns={invoiceColumns}
                                    rowKey="date"
                                />
                            </Card>
                        </>
                    )}
                </>
            )}
        </div>
    )
}

export default User